import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Sidebar from './components/Sidebar';
import Checklist from './components/Checklist';
import Configuracoes from './components/Configuracoes';
import NaoVendi from './components/NaoVendi';

import Nps from './components/npmEstrela';
import RelatorioNaoVendi from './components/RelatorioNaoVendi';

import AmigoFarma from './components/AmigoFarma';

import RelatorioNps from './components/RelatorioNpsEstrela';

function App() {
  return (
    <Router basename="/">
      <Routes>
        {/* Página de login - Não exibe Sidebar */}
        <Route path="/" element={<Login />} />
        
        {/* Páginas que exigem o Sidebar */}
        <Route path="/dashboard" element={<Sidebar><Dashboard /></Sidebar>} />
        <Route path="/naovendi" element={<Sidebar><NaoVendi /></Sidebar>} />
      
        <Route path="/relatorionaovendi" element={<Sidebar><RelatorioNaoVendi /></Sidebar>} />
        <Route path="/checklist" element={<Sidebar><Checklist /></Sidebar>} />
        <Route path="/configuracoes" element={<Sidebar><Configuracoes /></Sidebar>} />
        <Route path="/atendometro" element={<Nps />} />
        <Route path="/amigofarma" element={<Sidebar><AmigoFarma/></Sidebar>} />
        <Route path="/RelatorioNps" element={<Sidebar><RelatorioNps/></Sidebar>} />
   
      </Routes>
    </Router>
  );
}

export default App;
